/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MatchingConfigurationFromJSON, MatchingConfigurationToJSON, } from './MatchingConfiguration.js';
import { MatchingConfigurationReasonFromJSON, MatchingConfigurationReasonToJSON, } from './MatchingConfigurationReason.js';
/**
 * Check if a given object implements the SetCompanyMatchingConfigurationCommandDto interface.
 */
export function instanceOfSetCompanyMatchingConfigurationCommandDto(value) {
    if (!('reason' in value) || value['reason'] === undefined)
        return false;
    if (!('matchingConfiguration' in value) || value['matchingConfiguration'] === undefined)
        return false;
    return true;
}
export function SetCompanyMatchingConfigurationCommandDtoFromJSON(json) {
    return SetCompanyMatchingConfigurationCommandDtoFromJSONTyped(json, false);
}
export function SetCompanyMatchingConfigurationCommandDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'reason': MatchingConfigurationReasonFromJSON(json['reason']),
        'matchingConfiguration': MatchingConfigurationFromJSON(json['matchingConfiguration']),
    };
}
export function SetCompanyMatchingConfigurationCommandDtoToJSON(json) {
    return SetCompanyMatchingConfigurationCommandDtoToJSONTyped(json, false);
}
export function SetCompanyMatchingConfigurationCommandDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'reason': MatchingConfigurationReasonToJSON(value['reason']),
        'matchingConfiguration': MatchingConfigurationToJSON(value['matchingConfiguration']),
    };
}
